// How a chat reads in time (chat_controller): lines from one side close
// together are one group, with the clock under the last; each day starts
// with its name; the chat list gives each friend's latest line a short when.

// Lines this close, from the same side on the same day, are one group.
export const GROUP_GAP_MS = 5 * 60 * 1000

const DAY_MS = 86_400_000

const dayStart = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
const daysBetween = (at, now) => Math.round((dayStart(now) - dayStart(at)) / DAY_MS)
const valid = (date) => date instanceof Date && !Number.isNaN(date.getTime())

// "2:05 PM" or "14:05", in the reader's own clock.
export function chatClock(at) {
  if (!valid(at)) return ""
  return at.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
}

// The divider at the start of a day: "Today", "Yesterday", "Wednesday,
// Oct 21", and the year once it is not this one.
export function chatDay(at, now) {
  if (!valid(at)) return ""
  const ago = daysBetween(at, now)
  if (ago <= 0) return "Today"
  if (ago === 1) return "Yesterday"
  const options = { weekday: "long", month: "short", day: "numeric" }
  if (at.getFullYear() !== now.getFullYear()) options.year = "numeric"
  return at.toLocaleDateString([], options)
}

// The chat list's when: the clock today, then "Yesterday", the weekday for
// this week, then the date.
export function chatWhen(at, now) {
  if (!valid(at)) return ""
  const ago = daysBetween(at, now)
  if (ago <= 0) return chatClock(at)
  if (ago === 1) return "Yesterday"
  if (ago < 7) return at.toLocaleDateString([], { weekday: "short" })
  return at.toLocaleDateString([], { month: "short", day: "numeric" })
}

// For lines [{ senderId, at }] oldest first: whether each opens a day (and
// its name), and whether it joins the line before and after into a group.
export function chatLayout(lines, now) {
  const joins = (a, b) => a && b && a.senderId === b.senderId &&
    dayStart(a.at) === dayStart(b.at) && Math.abs(b.at - a.at) <= GROUP_GAP_MS

  return lines.map((line, index) => {
    const before = lines[index - 1]
    const after = lines[index + 1]
    const opensDay = !before || dayStart(before.at) !== dayStart(line.at)
    return {
      day: opensDay ? chatDay(line.at, now) : null,
      joinedPrev: Boolean(joins(before, line)),
      joinedNext: Boolean(joins(line, after))
    }
  })
}
